export const AGENT_OUTBOUND_MAX_DESTINATIONS = 10;
export const AGENT_OUTBOUND_MAX_MENTIONABLE_USERS = 50;
export const AGENT_OUTBOUND_DESTINATION_KEY_LENGTH = 8;

export const SLACK_WORKSPACE_ID_PATTERN = /^[TE][A-Z0-9]{6,20}$/;
export const SLACK_USER_ID_PATTERN = /^[UW][A-Z0-9]{6,20}$/;
export const SLACK_CHANNEL_ID_PATTERN = /^[CG][A-Z0-9]{6,20}$/;
export const SLACK_DIRECT_MESSAGE_ID_PATTERN = /^D[A-Z0-9]{6,20}$/;
export const AGENT_OUTBOUND_MAX_EMAIL_RECIPIENTS = 20;
export const AGENT_OUTBOUND_EMAIL_ADDRESS_MAX_LENGTH = 254;
export const AGENT_OUTBOUND_EMAIL_LABEL_MAX_LENGTH = 80;
// Anything that could split an address into several recipients or smuggle a header.
export const AGENT_OUTBOUND_EMAIL_FORBIDDEN_CHARS_PATTERN = /[<>,;"\\\s]/;
